export default __webpack_public_path__ + "static/4-method-2aa41abb12a86dbf655db3ee1b66388e.png";